import React from 'react';
import { Link, useLocation } from '@tanstack/react-router';
import { docTabs, getActiveTab } from './docNav';
import styles from './DocSidebar.module.css';

export const DocSidebar: React.FC = () => {
  const location = useLocation();
  const activeTab = getActiveTab(location.pathname);

  // Fall back to first tab if route not matched
  const sections = activeTab?.sections ?? docTabs[0].sections;

  return (
    <nav className={styles.nav}>
      {sections.map((section) => (
        <div key={section.title} className={styles.section}>
          <div className={styles.sectionLabel}>{section.title}</div>
          <ul className={styles.navItems}>
            {section.items.map((item) => (
              <li key={item.to}>
                <Link
                  to={item.to}
                  className={styles.navLink}
                  activeProps={{ className: `${styles.navLink} ${styles.active}` }}
                  activeOptions={{ exact: true }}
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </nav>
  );
};
